import React, { useContext } from "react";
import { client } from "../../../../graphql";
import { useQuery } from "@apollo/react-hooks";
import { shared } from "../../../graphql/shared";
import { MainMenu } from "../../../components/entrepreneur/shared";
import { useQueryFilters, useControlledPagination } from "../../../helpers";
import { FilterControlsOdes, SidebarLayout, Section } from "../../../components/shared";
import {
  MenuContext,
  CurrentUserContext,
  PaginationContext,
  ImportOdeModalProvider
} from "../../../contexts/shared";
import {
  default as OdesList
} from "../../../components/shared/ode-list";
import { CreateOdeModalProvider } from "../../../contexts/shared";

export const OdesIndex = () => {
  const { currentUser } = useContext(CurrentUserContext);
  const { setMenuState } = useContext(MenuContext);

  setMenuState({
    openKeys: ["odes"],
    selectedKeys: ["odes"]
  });

  const defaultVariables = { id: currentUser.id, first: 10 };

  const { loading, data, error, refetch, variables } = useQuery(
    shared.queries.getOdesByUserId,
    {
      client,
      variables: defaultVariables,
      fetchPolicy: "network-only"
    }
  );

  const { applyFilters } = useQueryFilters({ refetch });
  const { currentPage, onPaginationChange } = useControlledPagination({
    initialPageSize: 10
  });

  const onFiltersChange = filter => {
    const { skip, pageSize: first } = onPaginationChange(1);

    applyFilters((prevFilters = {}) => {
      if (!filter.batchId && !filter.programId) {
        // Omit for new ODEs without connected batch
        filter.batches_some = undefined;
      } else {
        filter.batches_some = {
          id: filter.batchId,
          program: { id: filter.programId }
        };
      }

      return ({
        ...prevFilters,
        ...filter,
        skip,
        first
      });
    });
  };

  const { registerRefetch } = useContext(PaginationContext);
  registerRefetch("odes", refetch, variables);

  return (
    <CreateOdeModalProvider>
      <ImportOdeModalProvider>
        <SidebarLayout menu={<MainMenu />}>
          <Section
            title="Compañías"
            spaced
            extra={<FilterControlsOdes onChange={onFiltersChange} />}>
            <OdesList
              data={data}
              error={error}
              isLoading={loading}
              onChangePage={onPaginationChange}
              currentPage={currentPage} />
          </Section>
        </SidebarLayout>
      </ImportOdeModalProvider>
    </CreateOdeModalProvider>
  );
};
